import { formatDate, StatusBadge } from '@ijoin/components';
import { useGetEnrollmentMap } from '@ijoin/hooks';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Stack,
  Typography
} from '@mui/material';

import { FC } from 'react';

import { Field } from './Field';

export const EnrollmentMapSection: FC<{
  planEnrollmentId: string;
  planId: string;
}> = props => {
  const mapDetail = useGetEnrollmentMap(props.planId, props.planEnrollmentId);

  if (mapDetail.isLoading) return <CircularProgress />;
  if (!mapDetail.data) return <Typography>No MAP data found.</Typography>;

  return (
    <Card sx={{ p: 1 }}>
      <CardHeader title='Managed Account Program' />
      <CardContent>
        <Box
          sx={{
            display: 'grid',
            gap: 3,
            gridTemplateColumns: 'repeat(3, 1fr)'
          }}>
          <div>
            <Typography gutterBottom variant='overline'>
              Program
            </Typography>
            <Stack spacing={1}>
              <Field
                label='Methodology'
                value={mapDetail.data.methodologyName ?? '-'}
              />
              <Field
                label='Entry Type'
                value={
                  <StatusBadge
                    severity={
                      mapDetail.data.entryExitTypeCode === 'O'
                        ? 'error'
                        : mapDetail.data.entryExitTypeCode === 'A'
                          ? 'warning'
                          : 'success'
                    }>
                    {mapDetail.data.entryType}
                  </StatusBadge>
                }
              />
              <Field
                label='Entry Date'
                value={
                  mapDetail.data.entryDate
                    ? formatDate(mapDetail.data.entryDate)
                    : '-'
                }
              />
            </Stack>
          </div>

          <div>
            <Typography gutterBottom variant='overline'>
              Status
            </Typography>
            <Stack spacing={1}>
              <Field
                label='Program Status'
                value={
                  mapDetail.data.programStatus ? (
                    <StatusBadge severity='info'>
                      {mapDetail.data.programStatus}
                    </StatusBadge>
                  ) : (
                    '-'
                  )
                }
              />
              <Field
                label='Opt-Out Date'
                value={
                  mapDetail.data.optOutDate
                    ? formatDate(mapDetail.data.optOutDate)
                    : '-'
                }
              />
              <Field
                label='Opt-Out Deadline'
                value={
                  mapDetail.data.optOutDeadline
                    ? formatDate(mapDetail.data.optOutDeadline)
                    : '-'
                }
              />
            </Stack>
          </div>

          <div>
            <Typography gutterBottom variant='overline'>
              Schedule
            </Typography>
            <Stack spacing={1}>
              <Field
                label='Auto Re-enrollment'
                value={mapDetail.data.autoReenrollment ? 'Yes' : 'No'}
              />
              <Field
                label='Next MAP Analysis'
                value={
                  mapDetail.data.nextMAPAnalysis
                    ? formatDate(mapDetail.data.nextMAPAnalysis)
                    : '-'
                }
              />
              <Field
                label='Last Reallocation Date'
                value={
                  mapDetail.data.lastReallocationDate
                    ? formatDate(mapDetail.data.lastReallocationDate)
                    : '-'
                }
              />
            </Stack>
          </div>
        </Box>
      </CardContent>
    </Card>
  );
};

EnrollmentMapSection.displayName = 'EnrollmentMapSection';
